import { View, Button } from "@/components/ui";
import { useRoute } from "@/components/shared/router";
import { ServiceProfessional } from "../service-professional";
import type { BookingCompleteScreenProps } from "..";
import { BookingConfirmationCard } from "@/containers/booking-complete/booking-confirmation-card";
import { AppointmentScheduledCard } from "@/containers/booking-complete/appointment-scheduled-card";
import { AddToCalendar } from "../add-to-calendar";
import { format } from "date-fns";
import { useMemo } from "react";
import { RecommendedBetaServices } from "@/components/shared/recommended-beta-services";

export const BookingCompleteScreen = ({
  calendarEvent,
  cleanerInfo,
  reviews,
  isAdHoc,
}: BookingCompleteScreenProps) => {
  const { push } = useRoute();
  const bookingDate = useMemo(() => {
    if (!calendarEvent.startTime) return "";
    return format(new Date(calendarEvent.startTime), "EEEE, MMMM d '@' h:mma");
  }, [calendarEvent.startTime]);
  return (
    <View className="mx-auto flex w-full max-w-[464px] flex-col gap-4 md:pt-6">
      <View className="flex flex-col gap-4 bg-background-intermediate p-4 md:rounded-xl">
        <BookingConfirmationCard />
        <AppointmentScheduledCard bookingDate={bookingDate} isAdHoc={isAdHoc} />
        <ServiceProfessional
          reviews={reviews}
          cleanerInfo={{
            star: cleanerInfo.star,
            name: cleanerInfo.name,
            avatar: cleanerInfo.avatar,
          }}
        />
      </View>
      <View className="fixed bottom-0 left-0 z-50 flex w-full flex-row gap-2 rounded-t-xl bg-white px-4 py-4 shadow-xl md:static md:hidden md:w-auto md:rounded-xl md:py-4 md:shadow-none">
        <View className="flex w-full flex-1 flex-col">
          <AddToCalendar
            title={calendarEvent.title}
            description={calendarEvent.description}
            location={calendarEvent.location}
            visits={calendarEvent.visits}
          />
        </View>
        <View className="flex w-1/2 flex-1">
          <Button
            variant="primary"
            color="CTA"
            fullWidth="full"
            rounded="full"
            size="md"
            onClick={() => push({ pageKey: "visits" })}
            children="View my Visits"
          />
        </View>
      </View>
      <RecommendedBetaServices />
    </View>
  );
};
